module.exports = __webpack_public_path__ + "media/images/new_landing/og-680ae577e3c6b29fe5f39ca0fff2c476.png";